module.exports = __webpack_public_path__ + "media/images/field-cancel-17c46f44.png";